import React, { useEffect, useState } from 'react'
import Container from './Container'
import Logo from '../assets/images/LOGO.svg'
import { ReactComponent as LanguageIcon } from '../assets/svg/languageIcon.svg'
import { ReactComponent as Phone } from '../assets/svg/phoneIcon.svg'
import { ReactComponent as MenuIcon } from '../assets/svg/menuIcon.svg'
import { ReactComponent as X } from '../assets/svg/xIcon.svg'
import IconButton from './IconButton'
import { useLocation } from 'react-router-dom'

function Header() {

    const [OpenMenu, setOpenMenu] = useState(false)

    const location = useLocation()

    useEffect(() => {

        setOpenMenu(false)

    }, [location])

    const [Position, setPosition] = useState(false)

    useEffect(() => {
      if(OpenMenu) {
            setPosition(false)
      }
      else {
        setTimeout(() => {
            setPosition(true)
        }, 300);
      }
    
      
    }, [OpenMenu])
    

    return (
        <div className={`bg-black overflow-hidden ${Position && 'relative'}`}>
            <Container>
                <div className='flex lg:justify-between items-center gap-5'>
                    <div className='p-4 bg-white rounded-br-[20px] rounded-bl-[20px]'>
                        <a href="#home">
                            <img src={Logo} alt="" className='w-[110px] sm:w-[150px] h-auto' />
                        </a>
                    </div>
                    <a href="#home" className='text-white font-medium text-lg hidden lg:block'>Home</a>
                    <a href="#services" className='text-white font-medium text-lg hidden lg:block'>Services</a>
                    <a href="#prices" className='text-white font-medium text-lg hidden lg:block'>Prices</a>
                    <a href="#about-us" className='text-white font-medium text-lg hidden lg:block'>About Us</a>
                    <a href="#contact-us" className='text-white font-medium text-lg hidden lg:block'>Contact Us</a>
                    <div className='items-center gap-1 hidden lg:flex'>
                        <LanguageIcon />
                        <select className='text-white font-medium text-lg bg-black outline-none'>
                            <option value="en">En</option>
                            <option value="de">De</option>
                        </select>
                    </div>
                    <a href="tel:+41313123131" className='ms-auto lg:ms-0'>
                        <IconButton icon={<Phone />} className='text-xs sm:text-xl'>
                            Call: 41 31 312 31 31
                        </IconButton>
                    </a>
                    <div className='cursor-pointer lg:hidden' onClick={() => setOpenMenu(!OpenMenu)}>
                        <MenuIcon className='w-[24px] h-[24px] sm:w-[45px] sm:h-[45px]' />
                    </div>
                </div>
            </Container>
            <div className={`w-[70%] h-screen top-0 lg:hidden absolute bg-black transition-all duration-300 z-50  ${OpenMenu ? 'left-[30%]' : 'left-[200vw]'} `}>

                <div className='flex flex-col gap-5 p-10'>
                    <div className='flex items-center justify-between'>
                        <a href="#home" className='text-white font-medium text-2xl sm:text-[40px]'>Home</a>
                        <div className='cursor-pointer' onClick={() => setOpenMenu(!OpenMenu)}>
                            <X className='w-[24px] h-[24px] sm:w-[45px] sm:h-[45px]' />
                        </div>
                    </div>
                    <a href="#services" className='text-white font-medium text-2xl sm:text-[40px]'>Services</a>
                    <a href="#prices" className='text-white font-medium text-2xl sm:text-[40px]'>Prices</a>
                    <a href="#about-us" className='text-white font-medium text-2xl sm:text-[40px]'>About Us</a>
                    <a href="#contact-us" className='text-white font-medium text-2xl sm:text-[40px]'>Contact Us</a>
                    <div className='flex justify-start'>
                        <div className='items-center gap-1 flex'>
                            <LanguageIcon className='w-[30px] h-[30px] sm:w-[50px] sm:h-[50px]' />
                            <select className='text-white font-medium text-2xl sm:text-[40px] bg-black outline-none'>
                                <option value="en">En</option>
                                <option value="de">De</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header